const DriverFilled = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" {...props}>
    <path d="M2.16667 15C2.16667 15 1 15 1 13.8333C1 12.6667 2.16667 9.16667 8 9.16667C13.8333 9.16667 15 12.6667 15 13.8333C15 15 13.8333 15 13.8333 15H2.16667ZM8 8C8.92826 8 9.8185 7.63125 10.4749 6.97487C11.1313 6.3185 11.5 5.42826 11.5 4.5C11.5 3.57174 11.1313 2.6815 10.4749 2.02513C9.8185 1.36875 8.92826 1 8 1C7.07174 1 6.1815 1.36875 5.52513 2.02513C4.86875 2.6815 4.5 3.57174 4.5 4.5C4.5 5.42826 4.86875 6.3185 5.52513 6.97487C6.1815 7.63125 7.07174 8 8 8V8Z" />
  </svg>
);

export { DriverFilled };
